/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import Delete from 'material/embeds/content/edit/delete/delete_container';
import Correct from 'material/embeds/content/edit/correct/correct_container';
import ImageIndicator from 'material/embeds/imageindicator/imageindicator';
// utils
import { url } from 'utils/urls';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/content/shared/answer/image2/image2_styles';



/* ========== ~~~~~~~~~~ EMBED : ANSWER : IMAGE 2 ~~~~~~~~~~ ========== */
class AnswerImage2 extends Component {
    constructor(props) {
        super(props);
        this.handleSelect = this.handleSelect.bind(this);
        this.getInlineStyles = this.getInlineStyles.bind(this);
        this.validateOption = this.validateOption.bind(this);
    }
    componentWillMount() {
        this.validateOption(this.props.imageURL, true);
    }
    componentDidUpdate(prevProps) {
        if(prevProps.imageURL !== this.props.imageURL || prevProps.isSelected !== this.props.isSelected) { this.validateOption(this.props.imageURL, false); }
    }
    handleSelect() {
        this.props.setActiveSelection(this.props.isSelected ? 'none' : `option_${this.props.optionId}`);
    }
    getInlineStyles() {
        const imgURL = this.props.imageURL === null ? `url(${url.image}/embed-default-image-${this.props.optionId}.jpg` : `url(${this.props.imageURL})`;
        const imgSrc = this.props.previewImageURL === null ? imgURL : `url(${this.props.previewImageURL})`;
        return { backgroundImage: imgSrc };
    }
    validateOption(imageURL, isInitialValidation) {
        const isValid = isInitialValidation ? imageURL === null ? imageURL : true : imageURL !== null;
        this.props.updateOptionProperty(this.props.contentId, this.props.optionId, 'isValid', isValid);
    }
    render() {
        return(
            <div className={`image2 ${this.props.classes.image2}`}>
                <span className={`graphic selected-${this.props.isEditable && this.props.isSelected} valid-${this.props.isValid} editable-${this.props.isEditable}`} style={this.getInlineStyles()} onClick={this.handleSelect}>
                    <span className={`overlay`} />
                    <ImageIndicator color={`white`} />
                </span>
                <Delete contentId={this.props.contentId} optionId={this.props.optionId} position={`top right`} />
                <Correct contentId={this.props.contentId} optionId={this.props.optionId} type={`image2`} />
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(AnswerImage2);
